<div *ngIf="quickBuild" class="in-depth-dashboard">
  <!-- Stats -->
  <div class="tw-hidden @md:tw-grid tw-grid-cols-1 @md:tw-grid-cols-3 tw-gap-6 tw-mb-4">
    <mat-card class="tw-p-3 @mdx:tw-p-4">
      <mat-card-title class="tw-text-lg @mdx:tw-text-2xl tw-flex" *ngIf="quickBuild?.name">
        {{ quickBuild?.name }}
      </mat-card-title>
    </mat-card>

    <!-- Total Coverage -->
    <app-reports-people-count
      [quickBuild]="quickBuild"
      [countType]="'total'"
      class="tw-flex"></app-reports-people-count>

    <!-- Active Employees -->
    <app-reports-people-count
      [quickBuild]="quickBuild"
      [countType]="'active'"
      class="tw-flex"></app-reports-people-count>
  </div>

  <div id="company-mode-charts" class="tw-flex tw-flex-col @md:tw-block">
    <!-- 2 charts container where 1st chart takes 2/3 of the width -->
    <div class="tw-grid tw-grid-cols-1 @xl:tw-grid-cols-3 tw-gap-4 tw-mb-4 tw-order-2">
      <div
        class="tw-bg-transparent dark:tw-bg-gray-800 tw-col-span-1 @xl:tw-col-span-2 tw-rounded-lg tw-p-3 @xxl:tw-p-6 tw-min-h-[300px] tw-flex tw-items-center tw-overflow-x-auto"
        tourAnchor="company-chart">
        <!-- talent flow chart -->
        <div class="tw-min-w-[720px] tw-w-full tw-h-full">
          <app-reports-prev-next-flow
            [quickBuild]="quickBuild"
            [reportTarget]="reportTarget"
            [dateFrom]="dateRangeStrings[0]"
            [dateTo]="dateRangeStrings[1]"
            [boxShadow]="false"
            [selectedSeries]="chartConfigs['talent-flow']?.selectedSeries"
            (configChange)="onChartConfigChange('talent-flow', $event)"></app-reports-prev-next-flow>
        </div>
      </div>

      <!-- people grid -->
      <div
        class="tw-bg-transparent dark:tw-bg-gray-800 tw-col-span-1 @xl:tw-col-span-1 tw-rounded-lg tw-p-3 @xxl:tw-p-6 tw-min-h-[300px] tw-flex tw-items-center tw-justify-center">
        <app-reports-people-grid
          class="tw-w-full tw-h-full"
          [quickBuild]="quickBuild"
          [boxShadow]="false"
          [movementType]="chartConfigs['people-grid']?.movementType"
          (configChange)="onChartConfigChange('people-grid', $event)"></app-reports-people-grid>
      </div>
    </div>

    <!-- job starts/ends chart (takes full-width) -->
    <div
      class="tw-bg-transparent dark:tw-bg-gray-800 tw-rounded-lg tw-p-3 @xxl:tw-p-6 tw-min-h-[300px] tw-flex tw-items-center tw-justify-center tw-mb-4 tw-order-1">
      <app-reports-job-starts-and-ends
        class="tw-w-full"
        [quickBuild]="quickBuild"
        [reportTarget]="reportTarget"
        [dateFrom]="dateRangeStrings[0]"
        [showAIAnalysis]="true"
        [dateTo]="dateRangeStrings[1]"
        [boxShadow]="false"
        [selectedBreakdownBy]="chartConfigs['job-starts-and-ends']?.selectedBreakdownBy"
        [selectedSeries]="chartConfigs['job-starts-and-ends']?.selectedSeries"
        (configChange)="onChartConfigChange('job-starts-and-ends', $event)"></app-reports-job-starts-and-ends>
    </div>

    <!-- functional distribution chart (takes full-width) -->
    <div
      class="tw-bg-transparent dark:tw-bg-gray-800 tw-rounded-lg tw-p-3 @xxl:tw-p-6 tw-min-h-[300px] tw-flex tw-items-center tw-justify-center tw-mb-4 tw-order-3">
      <app-reports-functional-distribution
        class="tw-w-full"
        [quickBuild]="quickBuild"
        [reportId]="'functional-distribution'"
        [boxShadow]="false"></app-reports-functional-distribution>
    </div>

    <!-- regular grid charts container -->
    <div class="tw-grid tw-grid-cols-1 @lg:tw-grid-cols-2 tw-gap-4 tw-mb-4 tw-order-4">
      <div
        class="tw-bg-transparent dark:tw-bg-gray-800 tw-rounded-lg tw-p-3 xxl:tw-p-6 tw-min-h-[300px] tw-flex tw-items-center tw-justify-center">
        <app-reports-demographics
          class="tw-w-full"
          [quickBuild]="quickBuild"
          [reportId]="'demographics-over-time'"
          [dateFrom]="dateRangeStrings[0]"
          [dateTo]="dateRangeStrings[1]"
          [boxShadow]="false"
          [breakdownByOptions]="[
            'jobs.function',
            'jobs.level',
            'education.school',
            'education.degree',
            'education.field',
            'jobs.metadata.previous_job.company.name'
          ]"
          [selectedBreakdownBy]="chartConfigs['demographics-over-time']?.selectedBreakdownBy"
          [selectedValueType]="chartConfigs['demographics-over-time']?.selectedValueType"
          (configChange)="onChartConfigChange('demographics-over-time', $event)"></app-reports-demographics>
      </div>
      <div
        class="tw-bg-transparent dark:tw-bg-gray-800 tw-rounded-lg tw-p-3 xxl:tw-p-6 tw-min-h-[300px] tw-flex tw-items-center tw-justify-center">
        <app-reports-demographics-current
          class="tw-w-full"
          [quickBuild]="quickBuild"
          [reportId]="'current-demographics'"
          [boxShadow]="false"
          [breakdownByOptions]="[
            'jobs.function',
            'jobs.level',
            'education.school',
            'education.degree',
            'education.field',
            'jobs.metadata.previous_job.company.name'
          ]"
          [selectedBreakdownBy]="chartConfigs['current-demographics']?.selectedBreakdownBy"
          [selectedValueType]="chartConfigs['current-demographics']?.selectedValueType"
          (configChange)="onChartConfigChange('current-demographics', $event)"></app-reports-demographics-current>
      </div>
      <div
        class="tw-bg-transparent dark:tw-bg-gray-800 tw-rounded-lg tw-p-3 xxl:tw-p-6 tw-min-h-[300px] tw-flex tw-items-center tw-justify-center">
        <app-reports-location-map
          class="tw-w-full"
          [quickBuild]="quickBuild"
          [reportTarget]="reportTarget"
          [boxShadow]="false"
          [selectedView]="chartConfigs['location-map']?.selectedView"
          (configChange)="onChartConfigChange('location-map', $event)"></app-reports-location-map>
      </div>
      <div
        class="tw-bg-transparent dark:tw-bg-gray-800 tw-rounded-lg tw-p-3 xxl:tw-p-6 tw-min-h-[300px] tw-flex tw-items-center tw-justify-center">
        <app-reports-tenure-current-breakdown
          class="tw-w-full"
          [quickBuild]="quickBuild"
          [reportTarget]="reportTarget"
          [boxShadow]="false"
          [breakdownByOptions]="[
            'jobs.function',
            'jobs.level',
            'education.school',
            'education.degree',
            'education.field',
            'jobs.metadata.previous_job.company.name'
          ]"
          [selectedBreakdownBy]="chartConfigs['tenure-current-breakdown']?.selectedBreakdownBy"
          (configChange)="onChartConfigChange('tenure-current-breakdown', $event)"></app-reports-tenure-current-breakdown>
      </div>
    </div>
  </div>
</div>
